let toCurrency = (value, emptyString) => {
  if (!!emptyString && !value) {
    return emptyString;
  }

  if (typeof value !== "number") {
    return value;
  }

  if (isNaN(value)) {
    value = 0;
  }

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
}

let toPercent = (value, emptyString) => {
  if (!!emptyString && !value) {
    return emptyString;
  }

  if (typeof value !== "number") {
    return value;
  }

  if (isNaN(value)) {
    value = 0;
  }

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
}

export {
  toCurrency,
  toPercent
}



// WEBPACK FOOTER //
// ./src/filters/global.js